import { FinancialManagementRouteMap } from '@/new-router/financial-management'

const pluginCharge = () => import('@/views/Export/pluginCharge')
const exportList = () => import('@/views/Export/exportList')
const Home = () => import('@/views/Home/home')

/**
* hidden: true                   是否显示在侧栏上
  nocache: true                  组件将不keep-alive
* meta : {
    title: 'title'               设置侧栏名字
    icon: 'svg-name'             侧栏icon图片名,
    showSubiems: ‘false’         侧栏的展开状态
    sort: 1,                     侧栏排序
    active: []                   业务逻辑的子页面高亮设置
  }
**/

export default [
  {
    path: '/export',
    name: 'export',
    component: Home,
    meta: {
      title: '数据导出',
      icon: 'icon-node',
      showSubiems: false,
      sort: 14,
      modules: 'export',
      permission: 'export:root',
    },
    children: [
      {
        path: 'plugin',
        name: 'pluginCharge',
        component: pluginCharge,
        meta: {
          title: '附加费用',
          active: ['pluginCharge'],
          permission: 'export:plugin',
          belong: [FinancialManagementRouteMap.FinancialManagement, FinancialManagementRouteMap.FinancialStatistics],
        },
      },
      {
        path: 'exportList',
        name: 'exportList',
        component: exportList,
        meta: {
          title: '导出列表',
          active: ['exportList'],
          permission: '',
        },
      },
    ],
  },
]
